import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GatewayResolver } from '../site-detail/services/GatewayResolver';

export const siteGatewayRedirectGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    const siteId = route.paramMap.get('idSite') ?? '';
    const deviceId = route.queryParamMap.get('idDevice');

    return inject(GatewayResolver)
        .resolveForDevice(deviceId, siteId)
        .pipe(
            map((gatewayId) =>
                router.createUrlTree(['/gateway', gatewayId], { queryParams: deviceId ? { deviceId } : {} }),
            ),
            catchError(() => of(router.createUrlTree(['/sites']))),
        );
};
